import { LoadingOutlined, LockOutlined } from "@ant-design/icons";
import { notification } from "antd";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  authUpdatePassword,
  sampleApiCall,
} from "../../apiservice/authService";
import useFormatApiRequest from "../../hooks/formatApiRequest";
import { useAppDispatch } from "../../Redux/reduxCustomHook";
import { NotificationType } from "../../utils/mscType.type";
import "./User-Profile-Comp.css";

const UserProfileChangePasswordComp = () => {
  const [formLoading, setFormLoading] = useState<boolean>(false);
  const [loadApi, setLoadApi] = useState(false);
  const [user, setUser] = useState<any>({});
  const [api, contextHolder] = notification.useNotification();

  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const handleInputChange = (event: any) => {
    const name = event.target.name;
    const value = event.target.value;
    setUser((values: any) => ({ ...values, [name]: value }));
  };

  const handleSubmit = (event: any) => {
    event.preventDefault();
    setLoadApi(true);
    setFormLoading(true);
  };

  const result = useFormatApiRequest(
    () => authUpdatePassword(user),
    loadApi,
    () => {
      setLoadApi(false);
    },
    () => {
      processApi();
    }
  );

  const processApi = async () => {
    if (result.httpState === "SUCCESS") {
      setFormLoading(false);
      openNotificationWithIcon(
        "info",
        "",
        "Password Changed Successfully",
        "#D9FFB5"
      );
    } else if (result.httpState === "ERROR") {
      setFormLoading(false);
      openNotificationWithIcon(
        "info",
        "",
        result.data?.response?.data?.errors?.[0] ||
          result.data?.response?.data?.message ||
          result.errorMsg ||
          "Error",
        "#FFC2B7"
      );
    }
  };

  const openNotificationWithIcon = (
    type: NotificationType,
    message: string,
    description: string,
    background?: string
  ) => {
    api[type]({
      message,
      description,
      placement: "bottomRight",
      style: { background },
    });
  };

  return (
    <>
      {contextHolder}
      <div className="grid p-4">
        <div className="mb-6">
          <p className="font-sans text-lg text-blue-800 dark:text-blue-400">
            Change Your Password
          </p>
        </div>

        <form onSubmit={handleSubmit}>
          {/* Old Password */}
          <div className="relative w-full mb-8">
            <label className="absolute -top-3 left-3 text-blue-800 dark:text-blue-400 px-1 bg-stone-100 dark:bg-stone-900 text-sm">
              {" "}
              {/* Assuming page bg is stone-100 light / stone-900 dark */}
              Old Password
            </label>
            <input
              required
              name="oldPassword"
              value={user?.oldPassword}
              onChange={handleInputChange}
              type="password"
              className="pl-10 pr-4 py-2 border border-blue-800 dark:border-blue-400 rounded-lg w-full h-16 bg-transparent text-black dark:text-stone-100 placeholder-gray-500 dark:placeholder-stone-400"
              placeholder="Enter Old Password"
            />
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              {/* Replace with an appropriate icon if needed */}
              <LockOutlined className="text-blue-800 dark:text-blue-400" />
            </div>
          </div>

          {/* New Password */}
          <div className="relative w-full mb-8">
            <label className="absolute -top-3 left-3 text-blue-800 dark:text-blue-400 px-1 bg-stone-100 dark:bg-stone-900 text-sm">
              New Password
            </label>
            <input
              required
              name="newPassword"
              value={user?.newPassword}
              onChange={handleInputChange}
              type="password"
              className="pl-10 pr-4 py-2 border border-blue-800 dark:border-blue-400 rounded-lg w-full h-16 bg-transparent text-black dark:text-stone-100 placeholder-gray-500 dark:placeholder-stone-400"
              placeholder="Enter New Password"
            />
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              {/* Replace with an appropriate icon if needed */}
              <LockOutlined className="text-blue-800 dark:text-blue-400" />
            </div>
          </div>

          {/* Confirm Password */}
          <div className="relative w-full mb-8">
            <label className="absolute -top-3 left-3 text-blue-800 dark:text-blue-400 px-1 bg-stone-100 dark:bg-stone-900 text-sm">
              Confirm Password
            </label>
            <input
              required
              name="confirmPassword"
              value={user?.confirmPassword}
              onChange={handleInputChange}
              type="password"
              className="pl-10 pr-4 py-2 border border-blue-800 dark:border-blue-400 rounded-lg w-full h-16 bg-transparent text-black dark:text-stone-100 placeholder-gray-500 dark:placeholder-stone-400"
              placeholder="Confirm Password"
            />
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              {/* Replace with an appropriate icon if needed */}
              <LockOutlined className="text-blue-800 dark:text-blue-400" />
            </div>
          </div>

          {/* Submit Button */}
          <div className="mb-2">
            <button className="w-full h-16 font-sans bg-blue-800 hover:bg-blue-700 dark:hover:bg-blue-600 text-white rounded-xl text-lg">
              {!formLoading ? (
                "Change Password"
              ) : (
                <LoadingOutlined rev={undefined} />
              )}
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default UserProfileChangePasswordComp;
